import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    tagName: 'style',

    initialize: function(options) {
        this.colour = options.colour || '#6042EC';
    },

    render: function() {
        var content =

        ':root {' +
            '--portal-theme: ' + this.colour + ';' +
            '--portal-theme-bg: ' + Util.hexToRgba(this.colour, 0.04) + ';' +
            '--portal-theme-bg-1: ' + Util.hexToRgba(this.colour, 0.02) + ';' +
            '--portal-theme-o-1: ' + Util.hexToRgba(this.colour, 0.1) + ';' +
            '--portal-theme-o-2: ' + Util.hexToRgba(this.colour, 0.2) + ';' +
            '--portal-theme-o-3: ' + Util.hexToRgba(this.colour, 0.3) + ';' +
            '--portal-theme-o-4: ' + Util.hexToRgba(this.colour, 0.4) + ';' +
            '--portal-theme-o-5: ' + Util.hexToRgba(this.colour, 0.5) + ';' +
            '--portal-theme-o-6: ' + Util.hexToRgba(this.colour, 0.6) + ';' +
            '--portal-theme-o-7: ' + Util.hexToRgba(this.colour, 0.7) + ';' +
            '--portal-theme-o-8: ' + Util.hexToRgba(this.colour, 0.8) + ';' +
            '--portal-theme-o-9: ' + Util.hexToRgba(this.colour, 0.9) + ';' +
        '}';

        this.$el.html(content);

        return this;
    }
});